import { SVGProps, Ref, forwardRef } from 'react';

export const RotateRightFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="m7.124 5.131-.99-.99.872-.871c-.907.008-1.62.033-2.204.111-.83.112-1.294.32-1.63.656-.337.336-.545.801-.656 1.631-.115.85-.116 1.973-.116 3.564v.1H1V9.18c0-1.527 0-2.744.128-3.698.133-.986.413-1.795 1.053-2.435s1.45-.92 2.435-1.053c.667-.09 1.46-.117 2.398-.125l-.88-.88.99-.989L9.69 2.566z"
            fill="currentColor"
        />
        <path d="M15 11c0-4.375-.625-5-5-5s-5 .625-5 5 .625 5 5 5 5-.625 5-5" fill="currentColor" />
    </svg>
));
RotateRightFilledSize16Glyph.displayName = 'RotateRightFilledSize16Glyph';
